module.exports = __webpack_public_path__ + "static/media/american_logo.76f0bd7f.svg";